import { useDispatch } from "react-redux";
import { fetchFileAttachmentAction } from "store/actions/files";
import { toast } from "react-toastify";
import { useCurrentUser, useLogout } from "utils/hooks";

interface useFetchAttachedFileProps {
  fileId: string;
  assignmentId?: string;
}

const useFetchAttachedFile = ({
  fileId,
  assignmentId,
}: useFetchAttachedFileProps) => {
  const dispatch = useDispatch();
  const { logOut } = useLogout();
  const { user } = useCurrentUser();

  const fetchFileAttachment = () => {
    return new Promise(() => {
      fetch(`${process.env.REACT_APP_API_URL}`, {
        method: "POST",
        credentials: "include",
        body: JSON.stringify({
          query: `
            query getFileAttachment($fileId: String!, $assignmentId: String) {
              getFileAttachment(fileId: $fileId, assignmentId: $assignmentId) {
                fileUrl
                title
                description
                order
                uuid
                addedBy
              }
            }
          `,
          variables: {
            fileId,
            assignmentId,
          },
        }),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          organizationId: user?.activeOrganizationId || "NA",
          permissionKey: "read_files",
        },
      })
        .then(async (res) => {
          if (res.status !== 200 && res.status !== 201) {
            const error = await res.json();
            if (error.errors[0].message.includes("BRKN_6001")) {
              toast.warn(`For security purposes please log in again.`);
              logOut();
            } else {
              toast.error(`Hmm, something went wrong.`);
              throw new Error("Failed!");
            }
          }
          return res.json();
        })
        .then((resData) => {
          if (resData.errors) {
            toast.error(
              `Hmm, something went wrong. ${resData.errors[0].message}`
            );
          } else {
            return dispatch(
              fetchFileAttachmentAction(resData.data.getFileAttachment)
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  };

  return {
    fetchFileAttachment,
  };
};

export default useFetchAttachedFile;
